import { render } from "./QRScanner.vue?vue&type=template&id=0671d901&scoped=true"
import script from "./QRScanner.vue?vue&type=script&lang=js"
export * from "./QRScanner.vue?vue&type=script&lang=js"

import "./QRScanner.vue?vue&type=style&index=0&id=0671d901&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0671d901"]])

export default __exports__